import { useMemo } from 'react';
import { Banner, Box, Text } from '@optiaxiom/react';

import { useOpalUser } from '@frontend/hooks/useOpalUser';

import { useGetTools } from '../../hooks';

export function ToolsWarningBanner() {
  const { opalUser } = useOpalUser();
  const { toolsResponse, isPending, error } = useGetTools(opalUser.instance.instance_id, true);

  const duplicateToolsNames = useMemo(() => {
    if (toolsResponse && toolsResponse.functions) {
      const toolNames = toolsResponse.functions.map(_function => _function.name);
      const uniqueToolNames = new Set(toolNames);
      return [...uniqueToolNames].filter(
        name => toolNames.indexOf(name) !== toolNames.lastIndexOf(name)
      );
    }
    return [];
  }, [toolsResponse]);

  if (isPending || error || duplicateToolsNames.length === 0) {
    return null;
  }

  return (
    <Banner intent="warning">
      <Box display="flex" flexDirection="row" gap="4">
        <Text>Duplicate tools detected:</Text>
        <Text fontWeight="600">{duplicateToolsNames.join(', ')}.</Text>
        <Text>Contact your administrator to resolve this issue.</Text>
      </Box>
    </Banner>
  );
}
